import CONTRATO from '@/graphql/querys/administracion/contratos/contrato.gql';
import CONTRATO_FIANZAS from '@/graphql/querys/administracion/contratos/fianzas/contratoFianzas.gql';
import CONTRATO_ESCALATORIAS from '@/graphql/querys/administracion/contratos/escalatorias/contratoEscalatorias.gql';
import CONTRATO_GASTOS from '@/graphql/querys/administracion/contratos/gastos/contratoGastos.gql';
import CONTRATO_REPORTES_FISICOS from '@/graphql/querys/administracion/ejecucion/reportesFisicos/contratoReportesFisicos.gql';
import CONTRATO_ESTIMACIONES from '@/graphql/querys/administracion/ejecucion/estimaciones/contratoEstimaciones.gql';
import CONTRATOS_CONVENIOS_MODIFICATORIOS from '@/graphql/querys/administracion/contratos/contrato/convenios.gql';
import mixAvanceProgramado from '@/helpers/calculos/mixAvanceProgramado';
import mixAvanceFinanciero from '@/helpers/calculos/mixAvanceFinanciero';
import mixAvanceFisico from '@/helpers/calculos/mixAvanceFisico';
import mixElementoPagadoEnSolicitud from '@/helpers/calculos/mixElementoPagadoEnSolicitud';

export default {
  name: 'AdministracionContratoEstadoDeCuenta',
  components: {

  },
  mixins: [
    mixAvanceProgramado, mixAvanceFinanciero, mixAvanceFisico,
    mixElementoPagadoEnSolicitud,
  ],
  apollo: {
    contrato: {
      query: CONTRATO,
      variables() {
        return {
          id: this.$route.params.idContrato,
        };
      },
    },
    contratoFianzas: {
      query: CONTRATO_FIANZAS,
      variables() {
        return {
          idContrato: this.$route.params.idContrato,
        };
      },
    },
    contratoEscalatorias: {
      query: CONTRATO_ESCALATORIAS,
      variables() {
        return {
          idContrato: this.$route.params.idContrato,
        };
      },
    },
    contratoGastos: {
      query: CONTRATO_GASTOS,
      variables() {
        return {
          idContrato: this.$route.params.idContrato,
        };
      },
    },
    contratoReportesFisicos: {
      query: CONTRATO_REPORTES_FISICOS,
      variables() {
        return {
          idContrato: this.$route.params.idContrato,
        };
      },
    },
    contratoEstimaciones: {
      query: CONTRATO_ESTIMACIONES,
      variables() {
        return {
          idContrato: this.$route.params.idContrato,
        };
      },
    },
    contratoConveniosModificatorios: {
      query: CONTRATOS_CONVENIOS_MODIFICATORIOS,
      variables() {
        return {
          idContrato: this.$route.params.idContrato,
        };
      },
    },
  },
  methods: {
  },
  computed: {
    getContrato() {
      if (!this.contrato) return {};
      return this.contrato;
    },
    getEstatus() {
      if (!this.contrato.estatus) return {};
      return this.contrato.estatus;
    },
    getContratoAnticipos() {
      if (!this.contrato.anticipos) return [];
      return this.contrato.anticipos
        .filter((a) => a.fecha <= this.fechaAlDeEstadoDeCuenta);
    },
    getContratoConvenios() {
      if (!this.contrato.convenios) return [];
      return this.contrato.convenios
        .filter((c) => c.fecha <= this.fechaAlDeEstadoDeCuenta)
        .sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));
    },
    getContratoFianzas() {
      if (!this.contratoFianzas) return [];
      return this.contratoFianzas
        .slice()
        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
        .filter((f) => f.fecha <= this.fechaAlDeEstadoDeCuenta);
    },
    getContratoEscalatorias() {
      if (!this.contratoEscalatorias) return [];
      return this.contratoEscalatorias
        .slice()
        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
        .filter((e) => e.fechaAl <= this.fechaAlDeEstadoDeCuenta);
    },
    getContratoGastos() {
      if (!this.contratoGastos) return [];
      return this.contratoGastos
        .slice()
        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
        .filter((g) => g.fechaAl <= this.fechaAlDeEstadoDeCuenta);
    },
    getContratoReportesFisicos() {
      if (!this.contratoReportesFisicos) return [];
      return this.contratoReportesFisicos.slice().sort((a, b) => b.numero - a.numero);
    },
    getConveniosModificatorios() {
      if (!this.contratoConveniosModificatorios) return [];
      return this.contratoConveniosModificatorios
        .filter((c) => c.fecha <= this.fechaAlDeEstadoDeCuenta)
        .sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));
    },
    /* Función para seleccionar la primera foto del reporte más reciente
    de las primeras 5 partidas
    */
    getContratoFotos() {
      if (!this.getContratoReportesFisicos) return [];
      const partidasFotos = this.getContratoReportesFisicos
        .filter((f) => f.fecha <= this.fechaAlDeEstadoDeCuenta)
        .map(
          (r) => r.partidas.map((p) => ({ idpartida: p.idPartida, imagenes: p.imagenes }))
            .filter((p) => p.imagenes !== null),
        ).filter((p) => p.length > 0).flat(2);

      let fotos = [];
      let noFoto = true;
      fotos.push({
        idpartida: partidasFotos[0]?.idpartida ? partidasFotos[0]?.idpartida : '',
        imagen: partidasFotos[0]?.imagenes[0] ? partidasFotos[0]?.imagenes[0] : '',
      });
      partidasFotos.forEach((f) => {
        noFoto = true;
        fotos.forEach((foto) => {
          if (foto.idpartida === f.idpartida) {
            noFoto = false;
          }
        });
        if (noFoto && f.imagenes[0]) {
          fotos
            .push({ idpartida: f.idpartida, imagen: f.imagenes[0] });
        }
      });
      if (fotos.length === 1 && fotos[0].idpartida === '') {
        fotos = [];
      }
      return fotos.map((f) => f.imagen).slice(0, 4);
    },
    getContratoEstimaciones() {
      if (!this.contratoEstimaciones) return [];
      return this.contratoEstimaciones
        .filter((e) => e.fechaAl <= this.fechaAlDeEstadoDeCuenta)
        .slice().sort((a, b) => a.numero - b.numero);
    },
    getAvanceFinancieroGenerales() {
      return this.mixAvanceFinancieroALaFecha(this.fechaAlDeEstadoDeCuenta).avance || 0;
    },
    getAvanceFisicoGenerales() {
      return this.mixAvanceFisicoFecha(this.fechaAlDeEstadoDeCuenta) || 0;
    },
    getAvanceProgramadoGenerales() {
      return this.mixCalcularPrograma(this.fechaAlDeEstadoDeCuenta).porcentaje || 0;
    },
    /* Función para obtener los datos del contrato modificados
    aplicando los convenios modificatorios
    */
    getDatosModificados() {
      const datosModificados = {
        fechaInicio: '',
        fechaTermino: '',
        importe: 0,
        iva: 0,
        total: 0,
      };
      let fechaXMonto = '';
      let fechaXPlazo = '';
      this.getContratoConvenios
        .forEach((c) => {
          if (c.tipo === 'PLAZO') {
            if (c.fecha >= fechaXPlazo || fechaXPlazo === '') {
              datosModificados.fechaInicio = c.fechaInicio;
              datosModificados.fechaTermino = c.fechaTermino;
              fechaXPlazo = c.fecha;
            }
          }
          if (c.tipo === 'MONTO - AMPLIACIÓN') {
            if (c.fecha >= fechaXMonto || fechaXMonto === '') {
              datosModificados.importe += c.importe;
              datosModificados.iva += c.iva;
              datosModificados.total += c.total;
              fechaXMonto = c.fecha;
            }
          }
          if (c.tipo === 'MONTO - REDUCCIÓN') {
            if (c.fecha >= fechaXMonto || fechaXMonto === '') {
              datosModificados.importe += c.importe;
              datosModificados.iva += c.iva;
              datosModificados.total += c.total;
              fechaXMonto = c.fecha;
            }
          }
          if (c.tipo === 'REPROGRAMACIÓN') {
            if (c.fecha >= fechaXPlazo || fechaXPlazo === '') {
              datosModificados.fechaInicio = c.fechaInicio;
              datosModificados.fechaTermino = c.fechaTermino;
              fechaXPlazo = c.fecha;
            }
          }
          if (c.tipo === 'PLAZO - MONTO AMPLIACIÓN') {
            if (c.fecha >= fechaXPlazo || fechaXPlazo === '') {
              datosModificados.fechaInicio = c.fechaInicio;
              datosModificados.fechaTermino = c.fechaTermino;
              fechaXPlazo = c.fecha;
            }
            if (c.fecha >= fechaXMonto || fechaXMonto === '') {
              datosModificados.importe += c.importe;
              datosModificados.iva += c.iva;
              datosModificados.total += c.total;
              fechaXMonto = c.fecha;
            }
          }
        });
      return {
        fechaInicio: datosModificados.fechaInicio,
        fechaTermino: datosModificados.fechaTermino,
        importe: datosModificados.importe + this.contrato.importe,
        iva: datosModificados.iva + this.contrato.iva,
        total: datosModificados.total + this.contrato.total,
      };
    },
    getImporteModificadoSinFinanciamiento() {
      if (!this.getConveniosModificatorios) return 0;
      const tiposConvenios = [
        'MONTO - AMPLIACIÓN',
        'MONTO - REDUCCIÓN',
        'PLAZO - MONTO AMPLIACIÓN',
      ];
      return this.getConveniosModificatorios
        .filter(({ tipo }) => tiposConvenios.includes(tipo))
        .map((c) => (c.importe - c.importeCostoFinanciero))
        .reduce((total, importe) => total + importe, 0);
    },
    // Funciones computed para GRAFICA
    importeDelContrato() {
      if (!this.contrato) return 0;
      const { importe: importeModificado } = this.contrato.modificado;
      const importeModificadoSinFinanciamiento = this.getImporteModificadoSinFinanciamiento;
      if (this.contrato.esObraFinanciada) {
        return (this.contrato.importeTotal + importeModificadoSinFinanciamiento);
      }
      return (this.contrato.importeTotal + importeModificado);
    },
    getUltimaFechaFinanciero() {
      const fechasFinanciero = this.mixGetAvanceFinanciero
        .map(({ fechaTermino }) => fechaTermino)
        .sort((a, b) => new Date(`${a} 00:00:0`) - new Date(`${b} 00:00:0`));

      return fechasFinanciero.pop();
    },
    getUltimaFechaProgramado() {
      const fechasPrograma = this.mixGetPrograma
        .map(({ fechaTermino }) => fechaTermino)
        .sort((a, b) => new Date(`${a} 00:00:0`) - new Date(`${b} 00:00:0`));

      return fechasPrograma.pop();
    },
    getUltimaFechaFisico() {
      const fechasFisico = this.mixGetAvanceFisico
        .map(({ fecha }) => fecha)
        .sort((a, b) => new Date(`${a} 00:00:0`) - new Date(`${b} 00:00:0`));

      return fechasFisico.pop();
    },
    fechas() {
      const fechasFinanciero = this.mixGetAvanceFinanciero
        .map(({ fechaTermino }) => fechaTermino);
      const fechasPrograma = this.mixGetPrograma
        .map(({ fechaTermino }) => fechaTermino);
      const fechasFisico = this.mixGetAvanceFisico
        .map(({ fecha }) => fecha);
      const fechas = [...fechasFinanciero, ...fechasPrograma, ...fechasFisico]
        .sort((a, b) => new Date(`${a} 00:00:0`) - new Date(`${b} 00:00:0`));

      return [...new Set(fechas)];
    },
    getAvanceFinancieroALaFecha() {
      return this.fechas
        .filter((fecha) => {
          if (!this.getUltimaFechaFinanciero) return false;
          return new Date(fecha) <= new Date(this.getUltimaFechaFinanciero);
        })
        .map((fecha) => ({
          fecha,
          avance: this.mixAvanceFinancieroALaFecha(fecha).avance || 0,
        }));
    },
    getAvanceProgramadoALaFecha() {
      return this.fechas
        .filter((fecha) => {
          if (!this.getUltimaFechaProgramado) return false;
          return new Date(fecha) <= new Date(this.getUltimaFechaProgramado);
        })
        .map((fecha) => ({
          fecha,
          avance: this.mixCalcularPrograma(fecha).porcentaje || 0,
        }));
    },
    getAvanceFisicoALaFecha() {
      return this.fechas
        .filter((fecha) => {
          if (!this.getUltimaFechaFisico) return false;
          return new Date(fecha) <= new Date(this.getUltimaFechaFisico);
        })
        .map((fecha) => ({
          fecha,
          avance: this.mixAvanceFisicoFecha(fecha) || 0,
        }));
    },
    getDataGrafica() {
      const dataSet = {
        programado: [0, ...this.getAvanceProgramadoALaFecha.map(({ avance }) => avance)],
        financiero: [0, ...this.getAvanceFinancieroALaFecha
          .filter((a) => a.fecha <= this.fechaAlDeEstadoDeCuenta).map(({ avance }) => avance)],
        fisico: [0, ...this.getAvanceFisicoALaFecha
          .filter((a) => a.fecha <= this.fechaAlDeEstadoDeCuenta).map(({ avance }) => avance)],
        fechas: ['-', ...this.fechas],
      };
      return dataSet;
    },
  },
};
